export { default } from './ProjectsSection';
